import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('hms_token'));
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('hms_session')) || null; }
    catch { return null; }
  });

  const login = (tok, nextUser) => {
    localStorage.setItem('hms_token', tok);
    localStorage.setItem('hms_session', JSON.stringify(nextUser));
    setToken(tok);
    setUser(nextUser);
  };

  const logout = () => {
    localStorage.removeItem('hms_token');
    localStorage.removeItem('hms_user');
    localStorage.removeItem('hms_session');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{
      token,
      user,
      username: user?.username || '',
      role: user?.role || '',
      login,
      logout,
      isAuth: Boolean(token && user?.role),
      isAdmin: Boolean(token && user?.role === 'admin'),
      isPortalUser: Boolean(token && ['student', 'staff'].includes(user?.role))
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
